var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 175,
    viewBox: "0 0 174 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10322_30380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.16 108.114H41.8428C39.8263 108.114 38.1914 106.479 38.1914 104.462V46.2837C38.1914 44.2672 39.8263 42.6323 41.8428 42.6323H104.16C106.176 42.6323 107.811 44.2672 107.811 46.2837V104.462C107.811 106.479 106.176 108.114 104.16 108.114Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3474 105.618V47.4397C39.3474 45.4232 40.9823 43.7884 42.9988 43.7884H105.316C106.028 43.7884 106.69 43.9954 107.251 44.3479C106.606 43.3186 105.464 42.6323 104.16 42.6323H41.8428C39.8263 42.6323 38.1914 44.2672 38.1914 46.2837V104.462C38.1914 105.767 38.8776 106.909 39.907 107.555C39.5544 106.993 39.3474 106.331 39.3474 105.618V105.618Z",
    fill: "url(#paint0_linear_10322_30380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4893 54.9248H49.5078V57.6022H96.4893V54.9248ZM96.4893 65.1481H49.5078V67.8255H96.4893V65.1481ZM96.4893 75.3737H49.5078V78.0511H96.4893V75.3737ZM96.4893 85.597H49.5078V88.2748H96.4893V85.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1094 76.9551L66.9152 88.7612H55.1094V76.9551Z",
    fill: "url(#paint1_linear_10322_30380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.069 92.192L112.978 128.227C112.724 130.029 111.182 131.368 109.363 131.368H36.6368C34.8175 131.368 33.2758 130.029 33.0213 128.227L26.142 79.5348C25.8317 77.3366 27.5375 75.3726 29.7575 75.3726H52.2168C54.0361 75.3726 55.5779 76.7115 55.8324 78.5126L56.7339 84.8893C56.9884 86.6908 58.5302 88.0297 60.3494 88.0297H114.454C116.673 88.0297 118.38 89.9938 118.069 92.192H118.069Z",
    fill: "url(#paint2_linear_10322_30380)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.033 115.294H45.9678C45.6715 115.294 45.3853 115.186 45.163 114.99C44.9407 114.794 44.7975 114.524 44.7601 114.23L44.0837 108.874C44.0622 108.703 44.0774 108.529 44.1282 108.364C44.1791 108.199 44.2645 108.047 44.3787 107.917C44.4929 107.788 44.6333 107.684 44.7907 107.613C44.948 107.542 45.1187 107.505 45.2914 107.505H100.709C100.882 107.505 101.052 107.542 101.21 107.613C101.367 107.684 101.507 107.788 101.622 107.917C101.736 108.047 101.821 108.199 101.872 108.364C101.923 108.529 101.938 108.703 101.917 108.874L101.24 114.23C101.203 114.524 101.06 114.794 100.837 114.99C100.615 115.186 100.329 115.294 100.033 115.294Z",
    fill: "white",
    fillOpacity: 0.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M119.683 152.91L160.188 173.606L163.969 162.639L124.228 149.419L119.683 152.91Z",
    fill: "url(#paint3_linear_10322_30380)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.576 118.887L132.543 119.988L129.441 150.369C129.441 150.369 129.169 150.673 128.51 150.555C127.851 150.437 127.16 150.07 127.16 150.07L125.083 125.918C125.083 125.918 123.881 134.459 123.965 136.861C124.029 138.671 124.647 140.88 124.979 142.769C125.264 144.394 125.864 148.279 125.864 148.279C125.864 148.279 125.155 148.603 124.778 148.676C124.401 148.749 123.918 148.347 123.918 148.347C123.918 148.347 119.021 138.841 118.958 137.036C118.895 135.231 118.576 118.887 118.576 118.887Z",
    fill: "#4B4F5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.701 148.303C123.701 148.303 123.079 149.423 122.306 150.106C121.533 150.789 120.008 151.604 119.661 151.975C119.313 152.345 119.693 152.891 119.693 152.891L123.43 152.761L126.417 150.234L125.999 147.827L123.701 148.303Z",
    fill: "#677285"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.793 149.6L130.666 152.02C130.666 152.02 129.233 153.13 127.253 153.439C125.273 153.747 123.909 153.273 123.909 153.273C123.909 153.273 123.552 152.553 124.225 152.245C124.535 152.104 125.228 151.516 125.837 150.763C126.112 150.424 127.147 149.692 127.147 149.692L129.793 149.6Z",
    fill: "#677285"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.052 103.048C136.052 103.048 137.197 104.789 137.899 104.323C138.601 103.858 142.983 99.366 142.983 99.366C142.983 99.366 144.287 98.3624 144.528 98.601C144.769 98.8396 144.093 99.366 144.093 99.366C144.093 99.366 145.516 99.5057 145.96 99.5057C146.404 99.5057 147.339 100.215 146.728 100.454C146.117 100.693 143.745 100.752 143.745 100.752C143.745 100.752 140.145 107.56 138.269 108.043C136.393 108.526 133.809 105.795 133.809 105.795L136.052 103.048Z",
    fill: "#FDE7E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.76 103.173C117.76 103.173 117.01 104.709 116.329 104.341C115.649 103.972 111.833 99.9473 111.833 99.9473C111.833 99.9473 110.562 99.1689 110.251 99.309C109.94 99.449 110.707 99.9473 110.707 99.9473C110.707 99.9473 108.837 100.099 108.485 100.24C108.133 100.382 107.723 100.815 108.255 101.012C108.787 101.21 110.823 101.35 110.823 101.35C110.823 101.35 113.653 106.942 115.797 107.596C117.942 108.25 119.768 105.674 119.768 105.674L117.76 103.173Z",
    fill: "#FDE7E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.704 98.4659V95.7182C124.704 95.7182 123.279 95.7904 122.7 94.8364C122.121 93.8824 121.965 91.1752 121.965 91.1752L122.401 89.9201L126.692 89.7388L128.947 91.6598L127.897 93.5137L127.697 93.87L128.697 98.0832L124.704 98.4659Z",
    fill: "#FDE7E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10322_30380",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 89,
    width: 8,
    height: 10
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.704 98.4659V95.7182C124.704 95.7182 123.279 95.7904 122.7 94.8364C122.121 93.8824 121.965 91.1752 121.965 91.1752L122.401 89.9201L126.692 89.7388L128.947 91.6598L127.897 93.5137L127.697 93.87L128.697 98.0832L124.704 98.4659Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10322_30380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.496 93.1075C126.228 94.6847 124.034 95.787 123.749 95.787C123.463 95.787 125.343 97.7651 125.343 97.7651L126.873 98.4664L129.045 98.0061L129.82 95.787L128.451 93.2693C128.451 93.2693 128.764 91.5304 127.496 93.1075Z",
    fill: "url(#paint4_linear_10322_30380)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.848 104.276L118.956 107.117L120.301 105.697C120.301 105.697 119.278 111.305 118.956 113.994C118.634 116.684 118.574 119.363 118.574 119.363C118.574 119.363 121.951 120.617 124.468 120.828C126.985 121.038 132.845 120.495 132.845 120.495L132.088 104.709L134.283 106.746L136.86 103.771C136.86 103.771 132.424 96.9541 131.585 96.557C130.746 96.1598 128.414 96.557 128.414 96.557C128.414 96.557 126.76 98.5152 126.088 98.5425C125.417 98.5699 123.929 96.557 123.929 96.557C123.929 96.557 121.551 96.1771 120.86 96.9541C120.168 97.731 116.848 104.276 116.848 104.276Z",
    fill: "#F26522"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M121.962 91.2059C121.962 91.2059 122.468 89.9298 123.128 90.1521C123.752 90.3625 124.293 90.8632 125.071 91.0982C125.848 91.3333 125.934 90.2775 126.462 90.4557C126.99 90.634 126.641 92.1872 127.014 92.4764C127.386 92.7657 127.386 90.4557 128.179 91.0776C128.973 91.6995 127.352 93.4498 127.352 93.4498C127.352 93.4498 127.559 94.5256 127.626 94.5988C127.693 94.672 127.685 93.8161 127.685 93.8161C127.685 93.8161 128.443 93.5252 128.766 92.2131C129.089 90.9009 129.229 90.3785 128.766 89.4251C128.303 88.4717 128.171 87.725 127.014 87.2753C125.856 86.8255 124.977 87.0014 124.168 87.2753C123.359 87.5491 122.773 88.0932 122.398 88.6347C121.526 89.9199 121.962 91.2059 121.962 91.2059Z",
    fill: "#4D364F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10322_30380",
    x1: 75.1422,
    y1: 77.5101,
    x2: 28.965,
    y2: 31.3325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10322_30380",
    x1: 62.9094,
    y1: 90.6555,
    x2: 48.6392,
    y2: 76.3857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10322_30380",
    x1: 72.1054,
    y1: 75.3726,
    x2: 72.1054,
    y2: 131.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#DCDDE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10322_30380",
    x1: 118.277,
    y1: 158.576,
    x2: 126.064,
    y2: 178.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFD3",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10322_30380",
    x1: 128.097,
    y1: 96.6214,
    x2: 128.097,
    y2: 93.9591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC0BE",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10322_30380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white",
    transform: "translate(26.1055 41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyUsers);
export default __webpack_public_path__ + "static/media/emptyUsers.ca5a78ec1e7ede1ebf483ed0e46667ee.svg";
export { ForwardRef as ReactComponent };